import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';
import { TooltipStyled } from './style.js';

var TooltipComponent = function TooltipComponent(_a) {
  var content = _a.content,
      referenceElement = _a.referenceElement,
      targetElement = _a.targetElement,
      placement = _a.placement,
      id = _a.id,
      rest = __rest(_a, ["content", "referenceElement", "targetElement", "placement", "id"]);

  var _b = useState(null),
      popperElement = _b[0],
      setPopperElement = _b[1];

  var _c = useState(null),
      arrowElement = _c[0],
      setArrowElement = _c[1];

  var _d = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 10
      }
    }]
  }),
      styles = _d.styles,
      attributes = _d.attributes;

  if (targetElement) {
    var target = document.querySelector(targetElement);
    return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(TooltipStyled, __assign({
      id: id,
      role: "tooltip",
      ref: setPopperElement,
      style: styles.popper
    }, attributes.popper, rest), content, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-arrow",
      ref: setArrowElement,
      style: styles.arrow
    })), target);
  }

  return /*#__PURE__*/React.createElement(TooltipStyled, __assign({
    id: id,
    role: "tooltip",
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper, rest), content, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-arrow",
    ref: setArrowElement,
    style: styles.arrow
  }));
};

export default TooltipComponent;